<template>
    <div>
        <div class="locationSideBar" :class="{fullHeight: (mapSettings.fullHeight || $route.query.datetime)}">
            <DayTimePickup v-if="$route.query.datetime"/>
            <BusinessList @choselocation="orderGormHere" v-else/>
        </div>
        <div class="botBtnBox mediaHideOnDesctop" v-if="!$route.query.datetime">
            <div class="container">
                <button @click="orderGormHere()" class="zbg mt-2">Order From Here</button>
            </div>
        </div>
    </div>
</template>

<script>
    import DayTimePickup from "./DayTimePickup";
    import BusinessList from "./BusinessList";
    import {mapState} from "vuex";
    import $ from "jquery";
    export default {
        name: "Sidebar",
        components: {BusinessList, DayTimePickup},
        computed: {
            ...mapState("businesses", ["list", "mapSettings"])
        },
        methods: {
            orderGormHere() {
                const bid = this.mapSettings.selectedBusinessID;
                if(this.mapSettings.selectedBusinessID) {
                    if (bid > -1) {
                        let business = this.$store.getters["businesses/getBusinessById"](bid);
                        this.$store.commit("shared/setBusinessId", bid)
                        this.$store.commit("cart/setBusiness", business);
                        this.$router.push({name: 'Locations', query: {datetime: 1}})
                        //this.$router.push({path: '/locations/order_daytime' })
                        this.$store.dispatch("shared/getGatewayInfo");
                    } else {
                        this.$store.commit("shared/setAlert", "Please select pickup location");
                    }
                    //console.log(bid);
                }
            }
        }
    }
</script>
